/* eslint-disable  */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Demo from './SkeletonDemo';
import Button from '../Button/Button';
import ButtonGroup from '../Button/ButtonGroup';
import marker from '../../images/marker.png';
import markerAlt from '../../images/marker-alt.png';
import { tr } from '../utils/locale';
import Input from '../Input/Input';

export default class MapDemo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            style: 'default',
            hasStores: false,
            hasPois: true,
        };
        this.map = null;
        this.marker = null;
        this.mounted = true;
        this.viewport = null;
        this.demoRef = React.createRef();
    }

    componentDidMount() {
        this.displayMap();
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    renderCode = () => {
        const { style, hasStores, hasPois } = this.state;

        let styleColor = '';
        if (style === 'grey') {
            styleColor = `
        {featureType: "all", stylers:[{"saturation": -100, "lightness": -30}]},`;
        }
        if (style === 'lightgrey') {
            styleColor = `
        {featureType: "all", stylers:[{"saturation": -100}]},`;
        }
        if (style === 'blue') {
            styleColor = `
        {featureType: "all", stylers:[{"hue": "#4998ff"}, {gamma:0.5}]},`;
        }
        const styleConf = `[${styleColor}
        {featureType: "poi", stylers:[{"visibility":"${hasPois ? 'on' : 'off'}"}]}
    ]`;
        const stores = hasStores
            ? `
const storesOverlay = new window.woosmap.map.StoresOverlay({
    breakPoint: 14,
    rules: [],
    default: {
        color: '#5586f7',
        size: 8,
        minSize: 1,
        icon: {
            url: marker,
            scaledSize: {
                height: 46,
                width: 30,
            },
        },
        selectedIcon: {
            url: markerAlt,
            scaledSize: {
                height: 46,
                width: 30,
            },
        },
    },
});
storesOverlay.setMap(map);
        `
            : '';

        return `const map = new window.woosmap.map.Map(document.getElementById('map'), {
    styles: ${styleConf},
    center: {
        lat: 51.52,
        lng: -0.13,
    },
    zoom: 14,
});

        ${stores}
        `;
    };

    renderHeaderFilters = () => {
        const { style } = this.state;

        const styleChoice = {
            key: 'usecase',
            label: tr('Choose your style'),
            component: (
                <ButtonGroup isLight key="usecase">
                    <Button
                        type="group"
                        active={style === 'default'}
                        onClick={() => {
                            this.setState({ style: 'default' }, this.displayMap);
                        }}
                        label={tr('Default')}
                    />
                    <Button
                        type="group"
                        active={style === 'blue'}
                        onClick={() => {
                            this.setState({ style: 'blue' }, this.displayMap);
                        }}
                        label={tr('Blue')}
                    />
                    <Button
                        type="group"
                        active={style === 'lightgrey'}
                        onClick={() => {
                            this.setState({ style: 'lightgrey' }, this.displayMap);
                        }}
                        label={tr('Light Grey')}
                    />
                    <Button
                        type="group"
                        active={style === 'grey'}
                        onClick={() => {
                            this.setState({ style: 'grey' }, this.displayMap);
                        }}
                        label={tr('Grey')}
                    />
                </ButtonGroup>
            ),
        };

        return [styleChoice];
    };

    renderFooterFilters = () => {
        const { hasStores, hasPois } = this.state;
        const filterPois = {
            label: '',
            key: 'pois',
            component: (
                <Input
                    label={tr('Display Map POIs')}
                    type="checkbox"
                    checked={hasPois}
                    onChange={(e) => {
                        this.setState({ hasPois: e.target.checked }, this.displayMap);
                    }}
                />
            ),
        };

        const filterStores = {
            label: '',
            key: 'stores',
            component: (
                <Input
                    label={tr('Display Woosmap Stores overlay')}
                    type="checkbox"
                    checked={hasStores}
                    onChange={(e) => {
                        this.setState({ hasStores: e.target.checked }, this.displayMap);
                    }}
                />
            ),
        };
        return [filterPois, filterStores];
    };

    displayMap = () => {
        const { style, hasStores, hasPois } = this.state;

        if (this.timeoutMap) {
            clearTimeout(this.timeoutMap);
        }

        const MapHTMLElement = this.demoRef?.current?.getMap();

        if (window?.woosmap?.map && MapHTMLElement) {
            window.woosmap.map.config.setApiKey('woos-48c80350-88aa-333e-835a-07f4b658a9a4');

            if (!this.storesOverlay) {
                this.storesOverlay = new window.woosmap.map.StoresOverlay({
                    breakPoint: 14,
                    rules: [],
                    default: {
                        color: '#5586f7',
                        size: 8,
                        minSize: 1,
                        icon: {
                            url: marker,
                            scaledSize: {
                                height: 46,
                                width: 30,
                            },
                        },
                        selectedIcon: {
                            url: markerAlt,
                            scaledSize: {
                                height: 46,
                                width: 30,
                            },
                        },
                    },
                });
            }

            const styles = [{ featureType: 'point_of_interest', stylers: [{ visibility: hasPois ? 'on' : 'off' }] }];
            const colorStyle = this.applyStyle(style);

            if (colorStyle) {
                styles.push(colorStyle);
            }
            if(!this.map ) {
                this.map = new window.woosmap.map.Map(MapHTMLElement, {
                    styles,
                    center: {
                        lat: 51.51,
                        lng: -0.12,
                    },
                    zoom: 15,
                });
            } else {
                this.map._style.setMapStyle(styles);
            }

            if (hasStores) {
                this.storesOverlay.setMap(this.map);
            } else {
                this.storesOverlay.setMap(null);
            }

            this.forceUpdate();
        } else {
            this.timeoutMap = setTimeout(this.displayMap, 300);
        }
    };

    applyStyle = (style) => {
        if (style === 'grey') {
            return { featureType: 'all', stylers: [{ saturation: -100, lightness: -30 }] };
        }
        if (style === 'lightgrey') {
            return { featureType: 'all', stylers: [{ saturation: -100 }] };
        }
        if (style === 'blue') {
            return { featureType: 'all', stylers: [{ hue: '#4998ff' }, { gamma: 0.3 }] };
        }
        return null;
    };

    render() {
        const { noheader } = this.props;

        const headerLabels = {
            title: tr('Map API'),
            desc: tr(
                'Woosmap Map is a vector tiles map based, which guarantees smooth zooming and panning transitions, a mobile-optimised loading and clear rendering at every scale. It provides a worldwide cover, cutting edge details and ability to display 3D buildings at closest/street zoom levels.'
            ),
        };

        return (
            <Demo
                ref={this.demoRef}
                header={headerLabels}
                id="map-demo"
                className="demo--map"
                footerFilters={this.renderFooterFilters()}
                headerFilters={this.renderHeaderFilters()}
                renderCode={this.renderCode}
                noheader={noheader}
                referer="http://localhost/"
                withMap
                response={null}
            />
        );
    }
}

MapDemo.defaultProps = {
    noheader: false,
};

MapDemo.propTypes = {
    noheader: PropTypes.bool,
};
